import userProfileTemplate from './user-profile/user-profile.html';
import managePlanTemplate from './manage-plan/manage-plan.html';
import changePasswordTemplate from './change-password/change-password.html';
import paymentsTemplate from './payments-profile/payments-profile.html';

export default /* @ngInject */ function($routeProvider) {
    $routeProvider.when('/user/profile', {
        templateUrl: userProfileTemplate,
        controller: 'UserProfileCtrl',
        title: 'User Profile',
        controllerAs: 'user',
        restrictAuthenticated: true,
        restrictPermission: 'view_profile'
    });

    $routeProvider.when('/user/manage-plan', {
        templateUrl: managePlanTemplate,
        controller: 'ManagePlanCtrl',
        title: 'Manage Plans',
        controllerAs: 'managePlan',
        restrictAuthenticated: true,
        restrictPermission: 'view_plan'
    });

    $routeProvider.when('/user/payments-profile', {
        templateUrl: paymentsTemplate,
        controller: 'PaymentsCtrl',
        title: 'Payments Profile',
        controllerAs: 'payments',
        restrictAuthenticated: true,
        restrictPermission: 'view_plan'
    });

    $routeProvider.when('/user/change-password', {
        templateUrl: changePasswordTemplate,
        controller: 'ChangePasswordCtrl',
        controllerAs: 'change',
        title: 'Change your password',
        restrictAuthenticated: true
    });
}



// WEBPACK FOOTER //
// ./user/user-routes.js